import React from 'react';
import { Heart, Mail, MapPin, Phone, Facebook, Instagram, Youtube } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-gradient-to-b from-black via-purple-950/20 to-black border-t border-purple-500/20">
      {/* Wave Effect */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-green-400 to-transparent" />

      <div className="container mx-auto px-6 lg:px-16 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="space-y-4">
            <h3 className="text-3xl font-display font-bold text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-purple-400">
              MASTERPLAN
            </h3>
            <p className="text-gray-400 leading-relaxed">
              Inspiring hearts through worship music since 2009. Based in Dubai, UAE.
            </p>
            <div className="flex gap-4 pt-2">
              <a
                href="#"
                className="p-3 bg-purple-600/20 rounded-lg hover:bg-purple-600/40 transition-all duration-300 hover:scale-110 group"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5 text-gray-400 group-hover:text-green-400 transition-colors duration-300" />
              </a>
              <a
                href="#"
                className="p-3 bg-purple-600/20 rounded-lg hover:bg-purple-600/40 transition-all duration-300 hover:scale-110 group"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5 text-gray-400 group-hover:text-green-400 transition-colors duration-300" />
              </a>
              <a
                href="#"
                className="p-3 bg-purple-600/20 rounded-lg hover:bg-purple-600/40 transition-all duration-300 hover:scale-110 group"
                aria-label="YouTube"
              >
                <Youtube className="w-5 h-5 text-gray-400 group-hover:text-green-400 transition-colors duration-300" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold text-white mb-4 uppercase tracking-wide">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <a href="#about" className="text-gray-400 hover:text-green-400 transition-colors duration-300">
                  About Us
                </a>
              </li>
              <li>
                <a href="#band" className="text-gray-400 hover:text-green-400 transition-colors duration-300">
                  Meet the Band
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-400 hover:text-green-400 transition-colors duration-300">
                  Contact Us
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-400 hover:text-green-400 transition-colors duration-300">
                  Book an Event
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold text-white mb-4 uppercase tracking-wide">Our Services</h4>
            <ul className="space-y-3 text-gray-400">
              <li>Worship Services</li>
              <li>Youth Events</li>
              <li>Conferences</li>
              <li>Concerts</li>
              <li>Special Events</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold text-white mb-4 uppercase tracking-wide">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-green-400 flex-shrink-0 mt-0.5" />
                <span className="text-gray-400">Dubai, United Arab Emirates</span>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-green-400 flex-shrink-0 mt-0.5" />
                <a href="mailto:info@masterplanband.com" className="text-gray-400 hover:text-green-400 transition-colors duration-300">
                  info@masterplan.band
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-green-400 flex-shrink-0 mt-0.5" />
                <a href="tel:+971501234567" className="text-gray-400 hover:text-green-400 transition-colors duration-300">
                  +971508212869
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-purple-500/20 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm text-center md:text-left">
              © {currentYear} MasterPlan. All rights reserved.
            </p>
            <p className="flex items-center gap-2 text-gray-500 text-sm">
              Made with <Heart className="w-4 h-4 text-red-500 animate-pulse" fill="currentColor" /> for worship
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
